/**
 * Premium baked table texture — photoreal racetrack asset.
 * Dynamic UI (pot, seats) overlays align to POT_ZONE percentages.
 */
import { useState } from 'react';
import { PHYSICAL_SEATS, POT_ZONE, seatAnchorOffset } from 'constants/seatLayout';
import TeenPattiTableTopDown from 'components/table/TeenPattiTableTopDown';

export { POT_ZONE };

const TABLE_IMAGE = `${process.env.PUBLIC_URL || ''}/assets/teen-patti-table-premium.png`;

interface Props {
  showSeatGuides?: boolean;
  previewMode?: boolean;
}

export default function BakedTableSurface({ showSeatGuides = false, previewMode = false }: Props) {
  const [useFallback, setUseFallback] = useState(false);

  if (useFallback) {
    return <TeenPattiTableTopDown showSeatGuides={showSeatGuides} previewMode={previewMode} liveMode={false} />;
  }

  return (
    <div className="tp-baked-table relative h-full w-full overflow-hidden rounded-[2rem]">
      <img
        src={TABLE_IMAGE}
        alt=""
        fetchPriority="high"
        decoding="async"
        onError={() => setUseFallback(true)}
        className="tp-baked-table-img pointer-events-none absolute inset-0 h-full w-full object-contain object-center"
        draggable={false}
      />
      <div className="tp-baked-table-vignette pointer-events-none absolute inset-0 rounded-[inherit]" aria-hidden />

      {showSeatGuides &&
        PHYSICAL_SEATS.map((s) => {
          const anchor = seatAnchorOffset(s);
          return (
          <div
            key={s.id}
            className="pointer-events-none absolute"
            style={{
              left: `${s.x}%`,
              top: `${s.y}%`,
              transform: `translate(${anchor.x}, ${anchor.y})`,
            }}
          >
            <span
              className={`rounded-full px-1.5 py-0.5 text-[8px] font-bold uppercase tracking-wider ${
                s.hero ? 'bg-tp-gold/90 text-black' : 'bg-black/60 text-tp-gold'
              }`}
              style={{ opacity: previewMode ? 1 : 0.7 }}
            >
              {s.hero ? 'YOU' : `P${s.seatNumber}`}
            </span>
          </div>
          );
        })}
    </div>
  );
}
